<template>
  <feather-icon
    icon="MessageCircleIcon"
    class="cursor-pointer mb-2 mr-2"
    :badge="unreadChats ? unreadChats : '' | persian_digits"
    @click="$router.push({ name: 'chat' })"
  />
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('chat/fetchChats')
  },
  computed: {
    unreadChats() {
      return this.$store.getters['chat/countUnseenMessages']
    }
  }
}
</script>
